import SVGInject from '@iconfu/svg-inject';

const svgSelector = "[js-svg]";

const allSvg = document.querySelectorAll(svgSelector);

SVGInject(allSvg);
